export default __webpack_public_path__ + "static/media/row-vertical.8662ef3b.svg";